import { useCallback } from 'react';
import { Paths } from 'shared/routes/paths';

import { useLogout } from './use-logout';

// After an email change or revert this browser's session is revoked. Signing out makes the auth listener reload the
// page, which would reopen the spent link; navigating away after it supersedes that reload.
export const useSignInAgain = () => {
  const logout = useLogout();

  return useCallback(async () => {
    await logout();
    window.location.replace(Paths.Login);
  }, [logout]);
};
